import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { Autocomplete, FormControl, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  VEHICLE_ASSIGNS,
} from "../../URLs/Apis";
import EquipImg from "../../assets/svg/Equipment.svg";
import defaultImg from "../../assets/svg/defultImage.svg";
import { newHost } from "../../pages/Categories/CategoryProfile";
import { newImageUrl } from "../../pages/Manufacturers/ManufactureProfile";

const  AssignEquipmentForm = ({getVehicleEquipment, handleClose , getVehicleById}) => {
  const { user } = useSelector((state) => state.auth);
  const TOKEN = "Bearer " + user?.token;
  const [mainServices, setMainServices] = useState([]);
  const [avialableEquipment, setAvialableEquipment] = useState([]);
 
const [selectedModel, setSelectedModel] = useState([]);
const [selectedEquipment, setSelectedEquipment] = useState([]);
const [selectedEquipmentId, setSelectedEquipmentId] = useState([]);
const [categoryId, setCategoryId] = useState(null);
const [sortOrder, setSortOrder] = useState("");

  const {id:vanId} = useParams();

const handleEquipmentChecked = (checked, equipment, model) => {
  if (checked) {

    setSelectedEquipment((prev) =>
      prev.some((e) => e.id === equipment.id) ? prev : [...prev, equipment]
    );

    setSelectedEquipmentId((prev) =>
      prev.includes(equipment.id) ? prev : [...prev, equipment.id]
    );

    setSelectedModel((prev) => {
      const exists = prev.some((m) => m.id === model.model.id);
      return exists ? prev : [...prev, model.model];
    });
  } else {
    setSelectedEquipment((prev) =>
      prev.filter((e) => e.id !== equipment.id)
    );
    setSelectedEquipmentId((prev) =>
      prev.filter((id) => id !== equipment.id)
    );

    setSelectedModel((prev) => {
      const hasOtherEquipment = selectedEquipment.some(
        (e) => e.model?.id === model.model.id && e.id !== equipment.id
      );
      return hasOtherEquipment
        ? prev
        : prev.filter((m) => m.id !== model.model.id);
    });
  }
};


  const getMainCategories = async () => {
    try {
      const response = await axios.get(`${newHost}portal/equipment-categories`, {
        headers: {
          Authorization: TOKEN,
        },
      });
      setMainServices(response.data.data.categories);
    } catch (error) {
      console.log(error);
    }
  };
  const ServicesCategoriesChange = async (id) => {
    setCategoryId(id)

  };
 const getAvailabeEquipmentToAssign = async () => {
  try {
    const response = await axios.get(
      `${newHost}portal/vehicles/equipment-models${categoryId ? `?category_id=${categoryId}` : ""}`,
      {
        headers: { Authorization: `Bearer ${TOKEN}` },
      }
    );

    let data = response.data.data.equipment_models;
    data = sortEquipment(data, sortOrder);
    setAvialableEquipment(data);

    if (selectedEquipment.length === 0) {
      const assignedEquipment = [];

      data.forEach((model) => {
        model.equipment?.assigned?.forEach((eq) => {
          const isAssignedToThisVan = eq?.current_assignments?.some(
            (a) => a.vehicle.id == vanId
          );
          if (isAssignedToThisVan) assignedEquipment.push(eq);
        });
      });

      setSelectedEquipment(assignedEquipment);
      setSelectedEquipmentId(assignedEquipment.map((e) => e.id));
      setSelectedModel(assignedEquipment.map((e) => e.model));
    }

  } catch (error) {
    console.log(error);
  }
};



const handleAssignToVan = async (e) => {
  e.preventDefault();

  try {
    const response = await axios.post(
      `${VEHICLE_ASSIGNS}/${vanId}/equipments/sync`,
      { equipment_ids: selectedEquipmentId },
      { headers: { Authorization: TOKEN } }
    );

    toast.success(response.data.data.message);
    console.log(response);
    
    getVehicleEquipment()
    getVehicleById()
    handleClose()
  } catch (error) {
    console.log(error);
      toast.error(error.response.message)
    error.response.data?.errors?.data?.failed?.forEach((fail) => {
            toast.error(fail.message)})
  error.response.data?.errors?.data?.successful?.forEach((success) => {
        toast.success(success.message)})
      }
};

const handleRemoveModel = (modelToRemove) => {
  setSelectedModel((prev) => prev.filter((m) => m.id !== modelToRemove.id));

  setSelectedEquipment((prev) =>
    prev.filter((eq) => eq.model?.id !== modelToRemove.id)
  );
  setSelectedEquipmentId((prev) => {
    const equipmentsOfModel =
      avialableEquipment.find((m) => m.model?.id == modelToRemove.id)
        ?.equipment?.all || [];
    const idsToRemove = equipmentsOfModel.map((e) => e.id);
    return prev.filter((id) => !idsToRemove.includes(id));
  });
};
const sortEquipment = (data, order) => {
  if (!order) return data;

  return [...data].sort((a, b) => {
    const nameA = a.model?.name?.toLowerCase() || "";
    const nameB = b.model?.name?.toLowerCase() || "";

    return order === "A to Z"
      ? nameA.localeCompare(nameB)
      : nameB.localeCompare(nameA);
  });
};

useEffect(() => {
  getAvailabeEquipmentToAssign()
}, [categoryId])
useEffect(() => {
  setAvialableEquipment((prev) => sortEquipment(prev, sortOrder));
}, [sortOrder])

  useEffect(() => {
    getMainCategories();
    
  }, []);
  return (
    <form onSubmit={handleAssignToVan}>
      <div className="">
              <div className="d-flex align-items-center gap-2">
                <div className="w-75">
              <label className="d-block text-black my-2">Service Category</label>
    
        
                  <FormControl className="w-100">
                         <Autocomplete
                                            size="small"
                                            options={mainServices.map((option) => {
                                              return {
                                                label: option.name,
                                                id: option.id,
                                                icon: option.icon_url
                                              }
                    
                    
                                            })}
                                             
                                            onChange={(e, item) => {
                                              ServicesCategoriesChange(item? item.id : null);
                                            }}
                    
                                            renderOption={(props, option) => (
                                          
                                                <div  {...props} className="d-flex gap-2 p-2">
                                                <img
                                   className="service-icon "
                                   src={
                                    option.icon? newImageUrl + option.icon : defaultImg
                                   }
                                   alt=""
                                 /> 
                                 {option.label}
                               </div>
                                            )}
                                            renderInput={(params) => <TextField {...params} placeholder="Select Category" />}
                                          />
                   
                    </FormControl> 
            </div>
        
            <div className="w-25">
  <FormControl className="w-100" variant="outlined">
    <label className="d-block text-black my-2">Sort by</label>
      <Autocomplete
                                            size="small"
                                            options={["A to Z" , "Z to A"].map((option) => {
                                              return {
                                                label: option,
                                                id: option,
                                              }
                    
                    
                                            })}
                                             
                                         value={sortOrder || ""}
                                         onChange={(e, item) => item? setSortOrder(item.label) : null }
                    
                                            renderOption={(props, option) => (
                                          
                                                <div  {...props} className="d-flex gap-2 p-2">
                                         
                                 {option.label}
                               </div>
                                            )}
                                            renderInput={(params) => <TextField {...params} placeholder="Sort by" />}
                                          />
    {/* <Autocomplete

      size="small"
      value={sortOrder}
      onChange={(e) => setSortOrder(e.target.value)} 
      displayEmpty
    >
      <MenuItem value="">
      </MenuItem>
      {["A to Z", "Z to A"].map((status) => (
        <MenuItem className="custom-menu-item" key={status} value={status}>
          <div className="label-size m-0">{status}</div>
        </MenuItem>
      ))}
    </Autocomplete> */}
  </FormControl>
</div>

            </div>
            {selectedModel.length > 0 && (
        <div className="mb-3 p-2">
          
      
          <div className="d-flex flex-wrap gap-2">
         {selectedModel.map((model) => (
  <div
    key={model.id}
    style={{ backgroundColor: "#D8D8D8" }}
    className="d-flex align-items-center px-2 py-1 border rounded-4 gap-1"
  >
    <img style={{ width: "20px" }} src={EquipImg} alt="" />
    <span>{model.name}</span>

    <div className="cursor" onClick={() => handleRemoveModel(model)}>
      <RemoveCircleIcon sx={{ color: "#A80101" }} />
    </div>
  </div>
))}

          </div>
        </div>
      )}
      
          </div>
          {avialableEquipment.length > 0 ? avialableEquipment.map((model) =>
   <div className="equipment-scroll-container">
       <div
      key={`equip-${model.model?.id}`}
      className="accordion custom-accordion custom-euip-accordion"
      id={`accordion-${model.model?.id}`}
    >
      <div className="border-bottom">
        <div className="accordion-item">
          <h2 className="accordion-header d-flex align-items-center">
            <img
              style={{ width: "50px" }}
              src={model.model?.default_image_url? model.model?.default_image_url: defaultImg}
              alt="Equipment"
            />
            <button
              className="accordion-button collapsed bg-transparent"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${model.model?.id}`}
              aria-expanded="false"
              aria-controls={`collapse-${model.model?.id}`}
            >
              <div>
                <p className="m-0">{model?.model?.name}</p>
                <p className="m-0 main-text-color">{model?.statistics?.status_breakdown?.available} Available</p>
              </div>
            </button>
          </h2>

          <div
            id={`collapse-${model.model?.id}`}
            className="accordion-collapse collapse"
            data-bs-parent={`#accordion-${model.id}`}
          >
          {model.equipment?.all?.map((available, index) => 
          
  {
     const isAvailable = available?.status?.value == "available";

  const isAssignedToThisVan = available.current_assignments?.some(
    (assign) => assign.vehicle?.id == vanId
  );

  const isDisabled = !isAvailable && !isAssignedToThisVan;

    return(
              <div  className="accordion-body">
    
      <div  className="row border-bottom  py-2 ">
        <div className="col-12 col-md-6 ">
          <div  className="d-flex align-items-center gap-2  w-100">
            <input 
            disabled={isDisabled}
  type="checkbox"
  checked={selectedEquipmentId.includes(available.id)}
  onChange={(e) => handleEquipmentChecked(e.target.checked, available, model)}
/>

            
            
            <h6 className={`m-0 ${isDisabled ? "opacity-25" : ""}`} style={{fontSize:"16px"}}>Serial No: {available.internal_serial_number}</h6>
          </div>
        </div>
        <div className="col-12 col-md-6 mb-0">
          <div className="row">
            <div className="col-12 col-md-6 align-items-center">
              <div className="d-flex align-items-center">
               <span className={`span-text-color px-3 rounded-5 bg-${available.status.color} ${isDisabled ? "opacity-25" : ""}`}>{available.current_condition?.condition}</span>
              </div>
             </div>
              <div className="col-12 col-md-6">
                <div className="d-flex align-items-center">
                <span className={`${isDisabled ? "opacity-25" : ""}`}>{available.status?.value}</span>
                </div>
            
          </div>
          </div>
    
     
        </div>
      </div>
    
</div>
    )})}
  
  
   
          </div>
        </div>
      </div>
    </div>
   </div>
  )
 

          : <><div className="">No available Equipment Models</div></>}
<div className="d-flex gap-3 justify-content-center align-items-center my-3 input-group-responsive fixed-footer">
              <button className="btn btn-dark px-5">Save</button>
              <button type="reset" onClick={handleClose} className="btn btn-light px-5">Cancel</button>
            </div>

    </form>
  );
};

export default AssignEquipmentForm;
